import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon, CheckmarkCircle02Icon } from '@hugeicons/core-free-icons'
import { useState } from 'react'

import { useAppStore } from '@/store'
import { cn } from '@/lib/utils'

const INTERESTS = ['2 Bedroom', '3 Bedroom', 'Penthouse', 'Undecided']

// Register-interest flow, rebuilt from the vanilla UI's waitlist modal on the
// Tower design system. Same behaviour as before the port: the submit is
// simulated — there is no backend in this project yet — and lands on a
// success state. Chip row instead of a <select> for the same reason the old
// UI did it: on iOS a select opens a full-screen wheel over the form.
export function RegisterModal() {
  const open = useAppStore((s) => s.registerOpen)
  const setOpen = useAppStore((s) => s.setRegisterOpen)
  const [interest, setInterest] = useState<string | null>(null)
  const [sent, setSent] = useState(false)

  if (!open) return null

  const close = () => {
    setOpen(false)
    setSent(false)
  }

  return (
    <div className="fixed inset-0 z-120 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />

      <div className="glass light-surface relative w-full max-w-md p-6">
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="text-foreground/50 hover:text-foreground absolute top-4 right-4 flex size-8 cursor-pointer items-center justify-center"
        >
          <HugeiconsIcon icon={Cancel01Icon} size={16} strokeWidth={2} />
        </button>

        {sent ? (
          <div className="flex flex-col items-center gap-3 py-8 text-center">
            <HugeiconsIcon
              icon={CheckmarkCircle02Icon}
              size={40}
              strokeWidth={1.5}
              className="text-primary"
            />
            <h2 className="font-serif text-2xl">You're on the list</h2>
            <p className="text-muted-foreground max-w-xs text-sm">
              Our residence team will contact you with availability and pricing for the
              Diriyah quarter.
            </p>
            <button
              type="button"
              onClick={close}
              className="bg-primary text-primary-foreground rounded-control mt-2 cursor-pointer px-5 py-2.5 text-sm font-semibold"
            >
              Done
            </button>
          </div>
        ) : (
          <form
            className="flex flex-col gap-4"
            onSubmit={(e) => {
              e.preventDefault()
              setSent(true)
            }}
          >
            <div>
              <h2 className="font-serif text-2xl">Register interest</h2>
              <p className="text-muted-foreground mt-1 text-sm">
                Be first to hear about availability in the Diriyah quarter.
              </p>
            </div>

            <label className="flex flex-col gap-1.5 text-sm font-medium">
              Name
              <input
                required
                name="name"
                autoComplete="name"
                className="border-input rounded-control bg-background/60 border px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40"
              />
            </label>
            <label className="flex flex-col gap-1.5 text-sm font-medium">
              Email
              <input
                required
                type="email"
                name="email"
                autoComplete="email"
                className="border-input rounded-control bg-background/60 border px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40"
              />
            </label>

            <fieldset className="flex flex-col gap-1.5">
              <legend className="text-sm font-medium">Interested in</legend>
              <div className="flex flex-wrap gap-1.5 pt-1.5">
                {INTERESTS.map((label) => (
                  <button
                    key={label}
                    type="button"
                    onClick={() => setInterest(label)}
                    aria-pressed={interest === label}
                    className={cn(
                      'rounded-control cursor-pointer px-3 py-1.5 text-sm transition-colors',
                      interest === label
                        ? 'bg-primary text-primary-foreground'
                        : 'surface-chip',
                    )}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </fieldset>

            <button
              type="submit"
              className="bg-primary text-primary-foreground rounded-control mt-1 cursor-pointer py-3 text-sm font-semibold transition-opacity hover:opacity-90"
            >
              Register interest
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
